<template>
  <div>
    <div class="tw-hidden md:tw-inline">
      <ul :class="['tw-flex tw-flex-wrap tw-items-end tw-text-xs md:tw-text-base tw-mb-0', dark ? 'tw-border-gray-200' : 'tw-border-gray-150', { 'tw-border-b': !noBorder }]">
        <li
          v-for="tab in tabs"
          :key="tab.title"
          :class="[
            'tw-cursor-pointer tw-py-2 tw-mr-6 tw-font-normal tw-text-sm tw--mb-px tw-border-b-2',
            { 'is-active tw-border-primary-500 tw-transition-all tw-duration-100': tab.isActive },
            tab.isActive ? active : nonActive,
          ]"
          @click="selectTab(tab)"
        >
          {{ tab.title }}
        </li>
      </ul>
    </div>
    <div class="tw-inline md:tw-hidden">
      <base-select light :filter-from-children="true" :options="tabOptions" @input="selectTab({ title: $event })" :value="selectedTab" />
    </div>
    <div>
      <slot />
    </div>
  </div>
</template>

<script>
import BaseSelect from "@/components/base/BaseSelect";

export default {
  components: {
    BaseSelect,
  },
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tabs: [],
    };
  },
  computed: {
    active() {
      return this.dark ? "tw-text-primary-500" : "tw-text-primary-500";
    },
    nonActive() {
      return this.dark ? "tw-text-gray-400 hover:tw-border-gray-400 tw-border-transparent" : "tw-text-gray-400 hover:tw-border-gray-400 tw-border-transparent";
    },
    tabOptions() {
      return this.tabs.map((tab) => ({
        label: tab.$props.title,
        value: tab.$props.title,
      }));
    },
    selectedTab() {
      const activeTab = this.tabs.find((tab) => tab.isActive);
      if (activeTab) {
        return activeTab.title;
      }
      return "";
    },
  },
  mounted() {
    this.tabs = this.$children.filter((child) => !child.$attrs["filter-from-children"]);
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach((tab) => {
        tab.isActive = tab.title === selectedTab.title;
      });
      this.$emit("click", selectedTab.title);
    },
  },
};
</script>
